import React from 'react';
import { Link } from 'react-router-dom';
import Brouchureone from "../../assests/brouchure1.jpg";
import BrouchureTwo from "../../assests/brouchure2.jpg";
import BrouchureThree from "../../assests/brouchure3.jpg";

function Brochures() {
  const brochures = [
    {
      title: "Presentation of the Ministry",
      image: Brouchureone,
      pdf: "/brochures/presentation.pdf",
    },
    {
      title: "How Can I Get Involved?",
      image: BrouchureTwo,
      pdf: "/brochures/get-involved.pdf",
    },
    {
      title: "Sponsorship Program",
      image: BrouchureThree,
      pdf: "/brochures/sponsorship.pdf",
    },
  ];

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#222",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "0 1.5rem 4rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            margin: "1.5rem 0 0",
            userSelect: "none",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            fontSize: "3rem",
            color: "#f58220",
            margin: "1rem 0 0.2rem",
            fontWeight: 700,
          }}
        >
          Brochures
        </h1>

        {/* Orange Dots */}
        <div
          style={{
            display: "flex",
            gap: "4px",
            marginBottom: "3rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#f58220",
              }}
            />
          ))}
        </div>

        {/* Brochure Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
            gap: "3rem",
            textAlign: "center",
          }}
        >
          {brochures.map((item, index) => (
            <div key={index}>
              <h2
                style={{
                  fontSize: "2rem",
                  fontWeight: "600",
                  marginBottom: "1.5rem",
                  color: "#333",
                }}
              >
                {item.title}
              </h2>

              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: "160px",
                  height: "240px",
                  objectFit: "cover",
                  boxShadow: "0 3px 12px rgba(0,0,0,.15)",
                }}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <div
                  style={{
                    width: "55px",
                    height: "8px",
                    background: "#f58220",
                  }}
                />

                <div
                  style={{
                    width: "55px",
                    height: "8px",
                    background: "#fff",
                  }}
                />

                <div
                  style={{
                    width: "55px",
                    height: "8px",
                    background: "#2f8b57",
                  }}
                />
              </div>

              <a
                href={item.pdf}
                download
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "20px",
                  padding: "12px 24px",
                  border: "6px solid #333",
                  color: "#333",
                  textDecoration: "none",
                  fontWeight: "600",
                  transition: ".3s",
                }}
              >
                <span>⬇</span>
                DOWNLOAD
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Brochures;
